module.exports = __webpack_public_path__ + "static/media/ldi-leaflet.ee670f70.pdf";